<template>
  <div class="content-page">
    <div class="tab-header">
      <el-button type="primary" size="medium" @click="addGroupPurcharse"
        >新增活动</el-button
      >
    </div>
    <div class="tab-content">
      <el-tabs
        v-model="activeName"
        type="card"
        style="width: 100%; padding-top: 10px"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="item in statusList"
          :key="item.id"
          :id="item.id"
          :label="item.name"
          :name="item.id"
        >
          <el-table :data="activeList" style="width: 100%" :max-height="550">
            <el-table-column
              align="left"
              prop="activityName"
              label="活动名称"
            ></el-table-column>
            <el-table-column align="center" prop="startTime" label="有效时间" width="380">
              <template slot-scope="scope">
                {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="activitySubType"
              label="活动类型"
              v-if="isVideoAccountActivities"
            >
              <template slot-scope="scope">
                {{ activitySubTypeMap[scope.row.activitySubType] }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="timeStatus" label="状态">
              <template slot-scope="scope">
                {{
                  scope.row.timeStatus == 1
                    ? "未开始"
                    : scope.row.timeStatus == 2
                    ? "进行中"
                    : scope.row.timeStatus == 3
                    ? "已结束"
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="lookDetail(scope.row)"
                  v-if="!isVideoAccountActivities"
                  >查看</el-button
                >
                <el-button type="primary" size="small" @click="updateActive(scope.row)"
                  >编辑</el-button
                >
                <el-button type="danger" size="small" @click="delActive(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-show="activeList.length > 0" style="padding-left: 15px">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.row"
        :current-page="queryInfo.pageNo"
        background
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  Marketing_activityList,
  getActivityListTotalNum,
  deleteActivity,
} from "../api/index";
export default {
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      activeList: [],
      activeName: "",
      statusList: [
        { id: "", name: "所有活动" },
        { id: "1", name: "未开始" },
        { id: "2", name: "进行中" },
        { id: "3", name: "已结束" },
      ],
      activitySubTypeMap: {
        201: "主页关注领券",
        202: "视频点赞领券",
        203: "转发朋友圈领券",
      },
    };
  },
  computed: {
    isVideoAccountActivities() {
      return this.$route.path == "/videoAccountActivities";
    },
  },
  watch: {
    $route(val) {
      this.getPageData();
    }, // 监听 $route 变化
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getMarketing_activityList() {
      Marketing_activityList({
        activityType: this.isVideoAccountActivities ? 200 : 2,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        timeStatus: this.activeName,
      }).then((res) => {
        if (res.code == 1) {
          this.activeList = res.data;
        } else if (res.code == -1) {
          this.activeList = [];
        } else {
        }
      });
    },
    getMarketing_activityListNum() {
      getActivityListTotalNum({
        activityType: this.isVideoAccountActivities ? 200 : 2,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        timeStatus: this.activeName,
      }).then((res) => {
        if (res.code == 1) {
          this.total = res.data.totalNum;
        } else {
          this.total = 0;
        }
      });
    },
    getPageData() {
      this.getMarketing_activityList();
      this.getMarketing_activityListNum();
    },
    handleClick(e) {
      this.getPageData();
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getMarketing_activityList();
    },
    lookDetail(row) {
      console.log(row, "lookDetail");
      localStorage.setItem("activityId", row.activityId);
      this.$router.push("/bargin/detail");
    },
    addGroupPurcharse() {
      if (this.isVideoAccountActivities) {
        this.$router.push("/videoAccountActivities/addAndEdit");
      } else {
        this.$router.push("/bargin/addAndEdit");
      }
    },
    updateActive(row) {
      console.log(row, "updateActive");
      localStorage.setItem("updateActivityId", row.activityId);
      if (this.isVideoAccountActivities) {
        this.$router.push("/videoAccountActivities/addAndEdit");
      } else {
        this.$router.push("/bargin/addAndEdit");
      }
    },
    delActive(row) {
      console.log(row, "delActive");
      this.$confirm("此操作将永久删除该活动, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        deleteActivity({
          activityId: row.activityId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
}
</style>
